<template>
  <div>
    <div class="spinner__wrapper" v-if="loading">
      <Spinner class="spinner" />
    </div>
    <slot v-if="!loading && !error"></slot>
    <Alert class="error" v-if="error">
      Beim Laden der Daten ist ein Fehler aufgetreten
    </Alert>
  </div>
</template>

<script>
  import { defineComponent } from 'vue'
  import { useShopData } from '@/composables/useShopData.ts'
  import Spinner from '@/components/icons/Spinner.vue'
  import Alert from '@/components/Alert.vue'

  export default defineComponent({
    components: { Spinner, Alert },
    setup() {
      const { loading, error } = useShopData()

      return { loading, error }
    },
  })
</script>

<style lang="scss" scoped>
  .spinner {
    width: 5rem;
    height: 5rem;
    animation: spin 1.8s linear 0s infinite;
  }

  .spinner__wrapper {
    height: 100%;
    min-height: 50vh;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .error {
    margin: $spacer20 $spacer05;
  }
</style>
